module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAA8CAMAAADbh/MlAAAAM1BMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACjBUbJAAAAEHRSTlMAv4BAz5/vUN8QYCAwr49wldxJeAAAAHtJREFUSMft1jkOhEAMRNHy4F5hZnz/04IaAhZRkCAR+MdPcmYbQFI7L4YCIBgv90h2lUDtMtjrjHas0IyA9XHjxo0bNysThZWf2/Px36UvN1owVakZ0BJiFHOVGFlMYrMKWj9mQiND3BrdoR6oW2LH251tl9z5Ae78EiPMRTQ9IKi5pgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/payment-methods/mpayment@2x.png
// module id = 605
// module chunks = 9